import { useMemo } from "react";
import { getConfigName } from "@helpers/funciones";
import { THEMES } from "@theme/index";

const useConfigName = (url?: string): keyof typeof THEMES | null => {
  return useMemo(() => {
    const configName = getConfigName(url || window.location.href);
    if (configName === null) return null;
    return configName as keyof typeof THEMES;
  }, [url]);
};

export default useConfigName;
